module.exports = __webpack_public_path__ + "img/PL08094.d888c279.png";